module.exports = __webpack_public_path__ + "img/image6@3x.57e82681.png";